<template>
<fragment>
    <div v-if="part==='home'" class="w-full h-screen flex flex-col items-center justify-between">
        <div class="flex flex-wrap w-full overflow-y-auto">
            <div class="w-full py-4 px-4 border-b border-gray-200 flex flex-row justify-center sticky top-0">
                <div>Deliver ASSET</div>
            </div>
            <div class="w-full h- py-4 px-4 border-b border-gray-200 flex flex-row justify-between">
                <div>Authorization</div>
                <div class="font-bold text-indigo-600" @click="forAuthorization()">{{itemName(authorization, 'Scan')}}</div>
            </div>
            <div class="w-full h- py-4 px-4 border-b border-gray-200 flex flex-row justify-between">
                <div>Box</div>
                <div class="font-bold text-indigo-600" @click="forBox()">{{itemName(box, 'Scan')}}</div>
            </div>
            <div class="w-full h- py-4 px-4 border-b border-gray-200 flex flex-row justify-between">
                <div>Signature</div>
                <div class="font-bold text-indigo-600" @click="forSignature()">{{(signature ? 'Signature OK' : 'Sign')}}</div>
            </div>
            <div class="w-full h- py-4 px-4 border-b border-gray-200 flex flex-row justify-between">
                <div>Damages</div>
                <div class="font-bold text-indigo-600">Select</div>
            </div>
            <div class="w-full h- py-4 px-4 border-b border-gray-200 flex flex-row justify-between">
                <div>Flags</div>
                <div class="font-bold text-indigo-600">Select</div>
            </div>
            <div class="w-full h- py-4 px-4 flex flex-row justify-center">
                <button @click="back" class="bg-indigo-600 mb-2 p-2 px-16 text-white rounded-lg">Deliver</button>
            </div>
            <div></div>
        </div>
        <div class="py-2 border-t border-gray-200 bg-white w-full text-center">
            <button @click="back" class="bg-gray-200 mb-2 p-2 px-16 text-indigo-700 rounded-lg focus:bg-indigo-200">Back</button>
        </div>
    </div>
    <Authorization v-if="part==='authorization'" v-on:back="part='home'" v-on:authorization="selectAuthorization"></Authorization>
    <Signature v-if="part==='signature'" v-on:back="part='home'" v-on:signature="selectSignature"></Signature>
    <Box v-if="part==='box'" v-on:back="part='home'" v-on:asset="selectBox"></Box>
</fragment>
</template>

<script>
    import Authorization from './Authorization.vue'
    import Signature from './Signature.vue'
    import Box from './Box.vue'

    export default {
        name: "Deliver",
        components : {
            Authorization,
            Box,
            Signature,
        },
        data: function() {
            return {
                qrCode: '',
                authorization: null,
                signature: null,
                asset: null,
                box: null,
                part: 'home'
            }
        },
        methods: {
            back() {
                this.$emit("back")
            },
            forSignature() {
                this.part = 'signature';
            },
            forAuthorization() {
                this.part = 'authorization';
            },
            forBox() {
                this.part = 'box';
            },
            selectAuthorization(item) {
                this.part = 'home';
                this.authorization = item;
            },
            selectSignature(item) {
                this.part = 'home';
                this.signature = item;
            },
            selectBox(box) {
                this.part = 'home';
                this.box = box;
            },
            itemName(item, def) {
                if(item===null) return def;
                return item;
            }
        }
    }
</script>

<style scoped>

</style>